<template>
  <div class="FullPeriodIoInfoWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      hide-default-footer
      disable-pagination
      :items="list"
      item-key=""
      :item-class="itemRowBackground"
    />
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("EntryDate"),
          value: "BeginDate",
        },
        {
          text: this.$t("DayName"),
          value: "EnterDayName",
        },
        {
          text: this.$t("EntryTime"),
          value: "BeginTime",
        },
        {
          text: this.$t("ExitTime"),
          value: "EndTime",
        },
        {
          text: this.$t("ExitDate"),
          value: "EndDate",
        },
        {
          text: this.$t("DurationTime"),
          value: "Duration",
        },
      ],
    };
  },
  methods: {
    itemRowBackground: function (item) {
    //  return item.Holiday > 0 ? 'style-1' : 'style-2'
     return item.Holiday == 2 ? 'style-1':item.Holiday == 1 ? 'style-2':'style-3'
  },
  },
};
</script>

<style>
.style-1 {
  background-color: rgb(196, 193, 46)
}
.style-2 {
  background-color: rgb(243, 89, 89)
}
.style-3 {
 
}
</style>